module.exports = __webpack_public_path__ + "img/palacio_04.f3d8b842.jpg";